import { getOrderList } from '@/api/orderlist'
import { getOrder } from '@/utils/auth'

const state = {
  orderProducts: [],
  orderLists: [],
  ordernumber: '',
  productInfo:{},
  orderinfo:[],
}

const getters = {
  
  totalCount(state){
    return state.orderProducts.reduce((sum,prod) => sum + prod.count, 0)
  },
  totalCounts(state){
    return state.orderProducts.reduce((sum,prod) => sum + prod.counts, 0)
  },
  totalPrice(){
    return state.orderProducts.reduce((sum, prod) => sum + Number(prod.prices), 0).toFixed(2)
  }
}

const mutations = {
  SET_ORDERS: (state, orders) => {

    orders.forEach(item => {
      item.counts = item.iids * item.times
    })
    state.orderProducts = orders
  },
  SET_ORDER_LIST: (state, orderList) => {
    state.orderLists = orderList
  },
  SET_ORDERNUMBER: (state, data) => {
    state.ordernumber = data[0].oid
  },
  SET_ORDER_INFO: (state,orderinfo) => {
    state.orderinfo = orderinfo
  }
}

const actions = {
  getFromOrder({ commit }) {
    return new Promise(resolve => {
      let orders = JSON.parse(getOrder())         //  转化为Object/Array
      commit('SET_ORDERS', orders)
      commit('SET_ORDERNUMBER', orders)
      resolve()
    })
  },
  getFromOrderList({ commit },query) {
    return new Promise((resolve, reject) => {
      getOrderList(query).then(
        res => {
          const data = JSON.parse(res.data)
          const orderlist = data.filter(item => item.constructor === Object)

          const orderinfo = []
          data.forEach(item => {
            if(item.constructor === Array) {
              orderinfo.push(...item)
            }
          })
          commit('SET_ORDER_LIST', orderlist)
          commit('SET_ORDER_INFO', orderinfo)
          resolve(res)
        }
      ).catch(error => {
        reject(error)
      })

    })
  }

}

export default{
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}





// WEBPACK FOOTER //
// ./src/store/modules/orderlist.js